<template>
  <div style="margin-top: 15px;">
    <div v-for="(v, k) in detailData" :key="k">
      <GraphCtxResult
        :group="null"
        :var="k"
        :title="k === 'CClimad' ? nameResults() : namevars[k]"
        :change="change"
        :data="summary.total[k]"
        :dataTarget="
          summary.processComp ? summary.processComp.total[k] : null
        "
        :generalContext="generalContext"
        :proceso="proceso"
        :items="false"
        :ranges="rangos"
        @switchSubGroups="$emit('switch-sub-groups', $event)"
      />
      <div v-for="(v1, k1) in v" :key="k1">
        <GraphCtxResult
          :group="null"
          :var="k1"
          :title="namevars[k1]"
          :change="change"
          :data="summary.total[k1]"
          :dataTarget="
            summary.processComp ? summary.processComp.total[k1] : null
          "
          :generalContext="generalContext"
          :proceso="proceso"
          :items="true"
          :active="v1.active"
          :ranges="rangos"
          @switchSubGroups="$emit('switch-sub-groups', $event)"
          @openMenuInter="$emit('open-menu-inter', $event)"
        />
        <!-- Whit Switch -->
        <article v-if="v1 && v1.active && !v1.unique" class="message">
          <div class="message-body">
            <div v-for="(v2, k2) in v1.data" :key="k2">
              <GraphCtxResult
                :group="k1"
                :var="v2"
                :title="namevars[v2]"
                :change="change"
                :data="summary.total[v2]"
                :dataTarget="
                  summary.processComp
                    ? summary.processComp.total[v2]
                    : null
                "
                :generalContext="generalContext"
                :proceso="proceso"
                :items="false"
                :ranges="rangos"
                @switchSubGroups="$emit('switch-sub-groups', $event)"
                @openMenuInter="$emit('open-menu-inter', $event)"
              />
            </div>
          </div>
        </article>
        <!-- Not Switch -->
        <div v-if="v1 && v1.data && v1.unique">
          <div v-for="(v2, k2) in v1.data" :key="k2">
            <GraphCtxResult
              :group="v1.group || k1"
              :var="v2"
              :title="namevars[v2]"
              :change="change"
              :data="summary.total[v2]"
              :dataTarget="
                summary.processComp
                  ? summary.processComp.total[v2]
                  : null
              "
              :generalContext="generalContext"
              :proceso="proceso"
              :active="false"
              :ranges="rangos"
              @switchSubGroups="$emit('switch-sub-groups', $event)"
              @openMenuInter="$emit('open-menu-inter', $event)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GraphCtxResult from "../graphCtxResult.vue";

export default {
  name: "Benchmark",
  components: {
    GraphCtxResult,
  },
  props: {
    summary: {
      type: Object,
      required: true,
    },
    namevars: {
      type: Object,
      required: true,
    },
    change: {
      type: Number,
      required: true,
    },
    rangos: {
      type: Function,
      required: true,
    },
    nameResults: {
      type: Function,
      required: true,
    },
    detailData: {
      type: Object,
      required: true,
    },
    generalContext: {
      type: Object,
      required: true,
    },
    proceso: {
      type: Object,
      required: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/climan/components/tabs/Benchmark.vue